import React from 'react';
import '../styles/WhatsAppPriceMatchWidget.css';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_PRICE_MATCH_NUMBER || '61470696015';

const PREFILLED_MESSAGE =
  "Hi AirFlyNow, I'd like a price match request. I have found a cheaper flight elsewhere and would like to send a screenshot for review.";

function WhatsAppPriceMatchWidget() {
  const whatsappHref =
    'https://wa.me/' +
    WHATSAPP_NUMBER +
    '?text=' +
    encodeURIComponent(PREFILLED_MESSAGE);

  return (
    <a
      className="pm-whatsapp"
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Found a cheaper fare? Send us a screenshot. Open WhatsApp for a price match request."
    >
      <span className="pm-whatsapp__tooltip" role="tooltip">
        Found a cheaper fare? Send us a screenshot.
      </span>

      <span className="pm-whatsapp__button" aria-hidden="true">
        <svg viewBox="0 0 32 32" className="pm-whatsapp__icon" focusable="false" aria-hidden="true">
          <path
            fill="currentColor"
            d="M19.11 17.41c-.28-.14-1.67-.82-1.93-.91-.26-.09-.45-.14-.64.14-.19.28-.73.91-.9 1.1-.16.19-.33.21-.61.07-.28-.14-1.17-.43-2.23-1.36-.83-.74-1.39-1.64-1.56-1.92-.16-.28-.02-.44.12-.58.12-.12.28-.33.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.64-1.54-.88-2.11-.23-.55-.47-.47-.64-.48h-.55c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.34 0 1.38 1 2.71 1.14 2.9.14.19 1.97 3.01 4.78 4.22.67.29 1.19.46 1.59.59.67.21 1.27.18 1.75.11.53-.08 1.67-.68 1.91-1.33.23-.66.23-1.22.16-1.33-.07-.12-.26-.19-.54-.33z"
          />
          <path
            fill="currentColor"
            d="M16 3C8.82 3 3 8.73 3 15.79c0 2.49.74 4.82 2.02 6.78L3.01 29l6.63-1.98A13.06 13.06 0 0 0 16 28.58c7.18 0 13-5.73 13-12.79C29 8.73 23.18 3 16 3zm0 23.45c-2.1 0-4.16-.57-5.95-1.66l-.43-.26-3.94 1.18 1.19-3.83-.28-.45a11.36 11.36 0 0 1-1.75-6.1C4.84 9.06 9.89 4.14 16 4.14c6.11 0 11.16 4.92 11.16 11.19 0 6.27-5.05 11.12-11.16 11.12z"
          />
        </svg>
      </span>
    </a>
  );
}

export default WhatsAppPriceMatchWidget;
